export function isSession(input) {
	return input && input.isSession;
}
